import { render, staticRenderFns } from "./title-header.vue?vue&type=template&id=2e8d2d94&scoped=true&"
import script from "./title-header.vue?vue&type=script&lang=ts&"
export * from "./title-header.vue?vue&type=script&lang=ts&"
import style0 from "./title-header.vue?vue&type=style&index=0&id=2e8d2d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d2d94",
  null
  
)

export default component.exports